import * as React from 'react';
import {styled} from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import {
    Cached,
    DeleteForeverOutlined,
    ImportContactsOutlined,
    PersonAddAlt,
    StorefrontOutlined
} from "@mui/icons-material";
import AddUserModule from "../shared-components/AddUserModule";
import {enums} from "../utils/enums";
import Stack from "@mui/material/Stack";
import {Divider, IconButton, useTheme} from "@mui/material";
import {useContext, useEffect, useState} from "react";
import {AppContext} from "../utils/AppContext";
import {collection, deleteDoc, doc, getDoc, getDocs, query, where} from "firebase/firestore";
import {db} from "../utils/firebaseApp";
import {toast} from "react-toastify";
import {Header} from "../shared-components/Header";
import MenuSideDrawer from "../shared-components/MenuSideDrawer";
import EditMenuModal from "../shared-components/modals/EditMenuModal";
import AddStandModule from "../shared-components/AddStandModule";
import Statistics from "./qr-code-scanner/Statisics";
import backgroundImage from '../assets/background.png'

const Item = styled(Paper)(({theme}) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

export default function FullWidthGrid() {
    const {state: {currentUser, stands, users, event}, dispatch} = useContext(AppContext);
    const [openMenuModal, setOpenMenuModal] = useState(false);
    const [openAddModal, setOpenAddModal] = useState(false);
    const [standToEdit, setStandToEdit] = useState(null);
    const theme = useTheme()
    const [bartenderTransactions, setBartenderTransactions] = useState([])
    const [bankerTransactions, setBankerTransactions] = useState([])

    async function getAllAdminData() {
        console.log('trying to get bar data')
        let stands = []
        try {
            const q = query(collection(db, "stands"), where("eventUid", "==", currentUser.event));
            const querySnapshot = await getDocs(q);
            querySnapshot.forEach((doc) => {
                // doc.data() is never undefined for query doc snapshots
                stands.push(doc.data())
            });
            console.log(stands)
            dispatch({stands: [...stands]})
        } catch (e) {
            console.log(e)
        }

        let users = []
        try {
            const usersForCurrentEvent = query(collection(db, "users"), where("event", "==", currentUser.event));
            const usersForCurrentEventSnapshot = await getDocs(usersForCurrentEvent);
            usersForCurrentEventSnapshot.forEach((doc) => {
                // doc.data() is never undefined for query doc snapshots
                users.push(doc.data())
            });
            console.log(users)
            dispatch({users: [...users]})
        } catch (e) {
            console.log(e)
        }
        let event = {}
        try {
            const docRef = doc(db, "events", currentUser.event);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                event = docSnap.data()
            }
            console.log(event)
            dispatch({event: event})
        } catch (e) {
            console.log(e)
        }
    }

    async function fetchTransactions() {
        console.log('trying to get bar data')
        let bankerTransactions = []
        // try {
        //     const q = query(collection(db, "bankerTransactions"), where("eventUid", "==", currentUser.event));
        //     const querySnapshot = await getDocs(q);
        //     querySnapshot.forEach((doc) => {
        //         // doc.data() is never undefined for query doc snapshots
        //         bankerTransactions.push(doc.data())
        //     });
        //     console.log(bankerTransactions)
        //     setBankerTransactions([...bankerTransactions])
        // } catch (e) {
        //     console.log(e)
        // }

        let bartenderTransactions = []
        try {
            const usersForCurrentEvent = query(collection(db, "bartenderTransactions"), where("event", "==", currentUser.event));
            const usersForCurrentEventSnapshot = await getDocs(usersForCurrentEvent);
            usersForCurrentEventSnapshot.forEach((doc) => {
                // doc.data() is never undefined for query doc snapshots
                bartenderTransactions.push(doc.data())
            });
            console.log(bartenderTransactions)
            setBartenderTransactions([...bartenderTransactions])
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        getAllAdminData()
    }, [])

    async function deleteUser(uid) {
        try {
            console.log(uid)
            await deleteDoc(doc(db, "users", uid));
            const updatedUsers = users.filter(u => u.uid !== uid)
            dispatch({users: [...updatedUsers]})
            toast.success('User deleted')
        } catch (e) {
            toast.error('User delete failed')
        }
    }

    async function deleteStand(uid) {
        try {
            await deleteDoc(doc(db, "stands", uid));
            const updatedStands = stands.filter(s => s.uid !== uid)
            dispatch({stands: [...updatedStands]})
            toast.success('Stand deleted')
        } catch (e) {
            toast.error('Stand delete failed')
        }
    }

    function editMenu(uid) {
        setStandToEdit(uid)
        setOpenMenuModal(true)
    }

    console.log(users)

    if (!users || !stands || !event) {
        return (
            <Box sx={{justifyContent: 'center', textAlign: 'center'}}>
                <Header/>
                <img src={'https://media.giphy.com/media/3oEjI6SIIHBdRxXI40/giphy.gif'} alt={'loading'}
                     style={{width: '100%', maxWidth: 300}}/>
                <Typography variant={'h2'}>Loading...</Typography>
            </Box>
        )
    }

    function getStandName(user) {
        console.log(user)
        console.log(stands)
        if (user.role !== enums.BARTENDER) return ''
        if (stands.length === 0) return 'No stand'
        return stands.filter(stand => stand.uid === user.stand)[0].name
    }


    return (
        <Box sx={{
            flexGrow: 1,
            backgroundColor: theme.palette.primary.offWhite,
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: 'cover',
            minHeight: '100vh'
        }}>
            <Header standName={event.name}/>
            <Grid container spacing={2} p={2}>
                <Grid item xs={12} md={6}>
                    <Box component={Paper} p={2} sx={{opacity: '0.9'}}>
                        <Typography variant={'h3'} sx={{marginBottom: 1}}><strong>Korisnici</strong></Typography>
                        <Button sx={{width: '170px', marginBottom: 5}} variant={'contained'}
                                onClick={() => setOpenAddModal('user')}>
                            <PersonAddAlt sx={{marginRight: 1}}/>
                            Dodaj Korisnika</Button>
                        {users && users?.map(user => {
                            if (user.role !== enums.ADMIN) {
                                return (
                                    <>
                                        <Stack direction={'row'} spacing={1} alignItems={'center'} flexGrow={1}>
                                            <IconButton onClick={() => deleteUser(user.uid)}>
                                                <DeleteForeverOutlined/>
                                            </IconButton>
                                            <>
                                                <Typography sx={{minWidth: '70px', textOverflow: 'ellipsis'}}
                                                            key={user.uid}>{user.role}</Typography>
                                                <Typography sx={{
                                                    minWidth: '150px',
                                                    wordWrap: 'break-word',
                                                    textOverflow: 'ellipsis'
                                                }}
                                                            key={user.uid}>{user.email}</Typography>
                                                <Typography
                                                    key={user.uid}>{getStandName(user)}</Typography>
                                            </>
                                        </Stack>
                                        <Divider variant={'fullWidth'}/>
                                    </>
                                )
                            }
                        })
                        }
                    </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Box component={Paper} p={2} sx={{height: 'calc(100% - 32px)', opacity: '0.9'}}>
                        <Typography variant={'h3'} sx={{marginBottom: 1}}><strong>Štandovi</strong></Typography>
                        <Button sx={{width: '170px', marginBottom: 5}} variant={'contained'}
                                onClick={() => setOpenAddModal('stand')}>
                            <StorefrontOutlined sx={{marginRight: 1}}/> Dodaj štand
                        </Button>
                        {stands && stands?.map(stand => {
                            return (
                                <>
                                    <Stack direction={'row'} spacing={2} alignItems={'center'} flexGrow={1}>
                                        <>
                                            <Button variant={'outlined'}
                                                    onClick={() => editMenu(stand.uid)}><ImportContactsOutlined
                                                sx={{marginRight: 1}}/>Meni</Button>
                                            <Typography sx={{minWidth: '200px'}}
                                                        key={stand.uid}>{stand.name}</Typography>
                                            {/*<Typography key={user.uid}>{stand.email}</Typography>*/}
                                            {/*<Typography key={user.uid}>{stand.stand}</Typography>*/}
                                        </>
                                        <IconButton onClick={() => deleteStand(stand.uid)}>
                                            <DeleteForeverOutlined/>
                                        </IconButton>
                                    </Stack>
                                    <Divider variant={'fullWidth'}/>
                                </>
                            )
                        })
                        }
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <Box component={Paper} p={2} sx={{opacity: '0.9'}}>
                        <Typography variant={'h3'} sx={{marginBottom: 1}}><strong>Statistika</strong></Typography>

                        <Button sx={{width: '170px', marginBottom: 5}} variant={'contained'}
                                onClick={() => fetchTransactions()}>
                            <Cached sx={{marginRight: 1}}/>
                            Učitaj podatke
                        </Button>

                        <Statistics transactions={{
                            bartender: bartenderTransactions,
                            banker: bankerTransactions
                        }}/>

                    </Box>
                </Grid>
            </Grid>
            <MenuSideDrawer open={openMenuModal} setOpen={setOpenMenuModal} standUid={standToEdit}/>
            <EditMenuModal open={openAddModal} setOpen={setOpenAddModal}
                           content={openAddModal === 'stand' ? <AddStandModule setOpenAddModal={setOpenAddModal}/> :
                               <AddUserModule setOpenAddModal={setOpenAddModal}/>}/>
        </Box>
    );
}
